/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-magic-numbers */
import React, { FC } from 'react'

const PhoneInput: FC<Partial<any>> = ({ children }) => (
  <>{children}</>
  // <TextField
  //   keepCharPositions
  //   showMask
  //   mask={mask}
  //   phoneMask={phoneMask}
  //   placeholder={prefix}
  //   clearThreshold={prefix.length + 1}
  //   type="tel"
  //   inputMode="tel"
  //   onChange={handlerChange}
  //   onFocus={focusHandler}
  //   onClick={clickHandler}
  //   onKeyDown={keyDownHandler}
  //   onPaste={handlePaste}
  //   {...rest}
  // >
  //   {children}
  // </TextField>
)

PhoneInput.defaultProps = {
  prefix: '+7 ',
  mask: ['+', '7', ' ', /[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
  onChange: undefined,
  onFocus: null,
  onClick: null,
  onKeyDown: null,
}

export default PhoneInput
